export class BreadCrumbsItem {
    constructor(public Id: number, public Name: string, public NameTranslated: string, public GroupId: number, public GroupName: string, public Path: number[]) {
    }
}